import {
	AMPERSAND,
	ANCHOR_HREF_VALUE,
	BREAKING_SPACES,
	CS_LINE_BREAK,
	EM_TAG,
	GREATHER_THAN,
	SPAN_TAG,
} from 'utils/contentStack/constants/regex'

export const normalizeText = (text: string) =>
	text
		.replace(CS_LINE_BREAK, '')
		.replace(BREAKING_SPACES, ' ')
		.replace(GREATHER_THAN, '>')
		.replace(SPAN_TAG, '')
		.replace(AMPERSAND, '&')
		.replace(EM_TAG, '')
		.replace(
			ANCHOR_HREF_VALUE,
			(_match, hrefContent) => `href="${hrefContent.trim()}"`
		)
